import { createFeatureSelector, type ActionReducerMap } from '@ngrx/store';

import type { HeatpumpsFunnelState } from './heatpumps-funnel/heatpumps-funnel.reducer';
import {
  heatpumpsFunnelReducer,
  heatpumpsFunnelKey,
} from './heatpumps-funnel/heatpumps-funnel.reducer';
import type { HeatpumpsOrderFormState } from './heatpumps-order-form/heatpumps-order-form.reducer';
import {
  heatpumpsOrderFormKey,
  heatpumpsOrderFormReducer,
} from './heatpumps-order-form/heatpumps-order-form.reducer';
import {
  heatpumpsQuestionnaireKey,
  type HeatpumpsQuestionnaireState,
  heatpumpsQuestionnaireReducer,
} from './heatpumps-questionnaire/heatpumps-questionnaire.reducer';

export const heatpumpsSelectorKey = 'eplus-heatpumps';

export interface HeatpumpsReducerState {
  readonly [heatpumpsFunnelKey]: HeatpumpsFunnelState;
  readonly [heatpumpsOrderFormKey]: HeatpumpsOrderFormState;
  readonly [heatpumpsQuestionnaireKey]: HeatpumpsQuestionnaireState;
}

export const eplusHeatpumpsFeature =
  createFeatureSelector<HeatpumpsReducerState>(heatpumpsSelectorKey);

export const heatpumpsReducers: ActionReducerMap<HeatpumpsReducerState> = {
  [heatpumpsFunnelKey]: heatpumpsFunnelReducer,
  [heatpumpsOrderFormKey]: heatpumpsOrderFormReducer,
  [heatpumpsQuestionnaireKey]: heatpumpsQuestionnaireReducer,
};
